module.exports = __webpack_public_path__ + "img/stand_xiaoman_1_cut.ded45c2b.png";